console.log("Chainwire JS Loaded");
if (!window.__cwFaqInit) {
  window.__cwFaqInit = true;
  document.addEventListener("DOMContentLoaded", function () {
    const faqItems = document.querySelectorAll(".cw-faq-item");
    if (!faqItems.length) return;
    faqItems.forEach(item => {
      const trigger = item.querySelector(".cw-faq-trigger");
      const content = item.querySelector(".cw-faq-content");
      const plus = item.querySelector(".cw-faq-plus");
      if (item.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
        trigger.setAttribute("aria-expanded", "true");
        plus.textContent = "\u2212";
      } else {
        content.style.maxHeight = "0px";
        trigger.setAttribute("aria-expanded", "false");
        plus.textContent = "+";
      }
      trigger.addEventListener("click", function () {
        const isOpen = item.classList.contains("active");
        faqItems.forEach(other => {
          other.classList.remove("active");
          other.querySelector(".cw-faq-content").style.maxHeight = "0px";
          other.querySelector(".cw-faq-trigger").setAttribute("aria-expanded", "false");
          other.querySelector(".cw-faq-plus").textContent = "+";
        });
        if (!isOpen) {
          item.classList.add("active");
          content.style.maxHeight = content.scrollHeight + "px";
          trigger.setAttribute("aria-expanded", "true");
          plus.textContent = "\u2212";
        }
      });
    });
  });
}